import CardFeed from './Container';

export default CardFeed;
